module.exports = global["hwcrypto"] = require("-!/opt/buildagent/work/2a87bc9b9c551e4e/epit-web-ui/node_modules/exports-loader/index.js?hwcrypto!/opt/buildagent/work/2a87bc9b9c551e4e/epit-web-ui/node_modules/babel-loader/lib/index.js??ref--6!./hwcrypto.js");


//////////////////
// WEBPACK FOOTER
// ./src/ui/lib/hwcrypto.js
// module id = 97
// module chunks = 1